import axios from 'axios'
import router from '../../router'
const state = {
  adminUserList: [],
  adminUserRtn: '',
  adminUserPwRtn: ''
}

const getters = {
  getAdminUser (state) {
    return state.adminUserList
  },
  getAdminUserRtn (state) {
    return state.adminUserRtn
  },
  getAdminUserPwRtn (state) {
    return state.adminUserPwRtn
  }
}

const mutations = {
  setAdminUser (state, payload) {
    state.adminUserList = payload
  },
  setAdminUserRtn (state, payload) {
    state.adminUserRtn = payload
  },
  setAdminUserPwRtn (state, payload) {
    state.adminUserPwRtn = payload
  }
}

const actions = {
  apiAdminUserList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getManagerSearch', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setAdminUser', response.data)
          if (response.data.length <= 0) {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          }
        })
    }
  },
  apiAdminUserTran (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/tranManagerData', payload)
          .then((response) => {
            // console.log('setAdminUserRtn = ' + response.data)
            context.commit('setAdminUserRtn', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response)
            // console.log(error.response)
            // console.log(JSON.stringify(error.response))
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            } else {
              alert('정상적으로 처리되지 않았습니다. ErrorCode : ' + error.response.status + ' / ErrorMsg : ' + error.response.statusText)
            }
            // alert(error.response.data.message)
          })
      })
    }
  },
  apiUserPwTran (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/tranManagerPw', payload)
          .then((response) => {
            // console.log('setAdminUserPwRtn = ' + response.data)
            context.commit('setAdminUserPwRtn', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            } else {
              alert('정상적으로 처리되지 않았습니다. ErrorCode : ' + error.response.status + ' / ErrorMsg : ' + error.response.statusText)
            }
            // alert(error.response.data.message)
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/adminuser.js